import * as React from 'react';

import AppSupport140 from './AppSupport140';

export const appSupport140 = () => <AppSupport140 />;

export default {
    title: 'Illustration/AppSupport140',
    component: AppSupport140,
    parameters: {
        notes: "`import AppSupport140 from 'box-ui-elements/es/illustration/AppSupport140';`",
    },
};
